<section class="example-section">
  <h6>{{ group.label }}</h6>

  <!-- Exclusive group → radio buttons -->
  @if (group.exclusive) {
    <mat-radio-group
      [value]="value[0]"
      (change)="selectExclusive($event.value)"
      [disabled]="disabled"
    >
      @for (item of group.optionItems; track item.id) {
        <mat-radio-button [value]="item.id">
          {{ item.label }}
        </mat-radio-button>
      }
    </mat-radio-group>
  }

  <!-- Non-exclusive group → checkboxes -->
  @else {
    @for (item of group.optionItems; track item.id) {
      <p>
        <mat-checkbox
          [checked]="isChecked(item.id)"
          (change)="toggleItem(item.id, $event.checked)"
          [disabled]="disabled"
        >
          {{ item.label }}
        </mat-checkbox>
      </p>
    }
  }
</section>
